import { createApi } from '@reduxjs/toolkit/query/react';
import { backend_server_address } from '../../../../../backendServer';
import { axiosBaseQuery } from '../../../../../store/utility';

export const usersAPI = createApi({
    reducerPath: 'usersAPI',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/login/user/' }),
    tagTypes: ['UserList', 'User', 'UserSchema'],
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => ({
                url: '',
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: (result) => {
                return result?.data ? [{ type: 'UserList' }, 'UserList'] : ['UserList'];
            },
        }),
        getUserSchema: builder.query({
            query: () => ({
                url: 'schema/',
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: (result) => {
                return result ? [{ type: 'UserSchema' }] : ['UserSchema'];
            },
        }),
        getUserById: builder.query({
            query: (id) => ({
                url: `${id}/`,
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: (result) => {
                return result?.data ? [{ type: 'User', id: result.data.id }] : ['User'];
            },
        }),
        createUser: builder.mutation({
            query: (data) => {
                window.gtag('event', 'user_create', {
                    event_category: 'user',
                });
                return {
                    url: '',
                    method: 'POST',
                    withCredentials: true,
                    data: data,
                };
            },
            invalidatesTags: (result) => ['User'],
        }),
        editUser: builder.mutation({
            query: ({ data, id }) => {
                window.gtag('event', 'user_edit', {
                    event_category: 'user',
                });
                return {
                    url: `${id}/`,
                    method: 'PATCH',
                    withCredentials: true,
                    data: data,
                };
            },
            invalidatesTags: (result) => (result?.data ? [{ type: 'User', id: result.data.id }] : ['User']),
        }),
    }),
});

export const {
    endpoints,
    useGetUsersQuery,
    useGetUserSchemaQuery,
    useGetUserByIdQuery,
    useCreateUserMutation,
    useEditUserMutation,
} = usersAPI;
export const usersAPIReducer = usersAPI.reducer;
export const usersAPIReducerPath = usersAPI.reducerPath;
export const usersAPIReducerMiddleware = usersAPI.middleware;
